import { createFitbitExtraction, FitbitExtractionJob, FitbitExtractionRequest } from './fitbitExtractionService';

export type BatchExtractionItem = { name: string; request: FitbitExtractionRequest; job?: FitbitExtractionJob; error?: string };
// Stable request IDs survive retries. Acknowledged jobs are never resubmitted.
// Each existing API request independently verifies study and participant access.
export async function submitFitbitExtractionBatch(studyId: string, items: BatchExtractionItem[],
  active: () => boolean, progress: (processed: number) => void,
  createExtraction: typeof createFitbitExtraction = createFitbitExtraction) {
  let next = 0, processed = items.filter(item => item.job).length;
  const pending = items.filter(item => !item.job);
  progress(processed);
  await Promise.all(Array.from({ length: Math.min(3, pending.length) }, async () => {
    while (active() && next < pending.length) {
      const item = pending[next++]; delete item.error;
      try { item.job = (await createExtraction(studyId, item.request)).job; }
      catch (error) { item.error = error instanceof Error ? error.message : 'Could not start this extraction. Please retry.'; }
      processed++; if (active()) progress(processed);
    }
  }));
  return items;
}
